import type { DeliverySlot } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export interface AvailableSlotsQuery {
  availableSlots: DeliverySlot[]
}
export interface AvailableSlotsVariables {
  shopId: GQL_ID
}

export const GQL_QUERY_AVAILABLE_SLOTS = gql`
  query ($shopId: ID!) {
    availableSlots(shop_id: $shopId) {
      id
      shop_id
      shop {
        id
        address
      }
      period {
        from
        to
      }
      slotTime
      availableUntil
    }
  }
`

export const useFetchAvailableSlots = (shopId?: GQL_ID) => {
  const { data, loading, refetch, error } = useQuery<AvailableSlotsQuery, AvailableSlotsVariables>(GQL_QUERY_AVAILABLE_SLOTS, {
    variables: {
      shopId: shopId!
    },
    skip: !shopId
  })

  const slots = data?.availableSlots

  return {
    slots,
    data,
    loading,
    refetch,
    error
  }
}
